import React from 'react';
import BacktestBanner from '../components/services-backtest/BacktestBanner';
import HomeTestimonial from '../components/home/HomeTestimonial';
import BacktestStrategy from '../components/services-backtest/BacktestStrategy';
import BacktestPerformance from '../components/services-backtest/BacktestPerformance';
import BacktestStimulation from '../components/services-backtest/BacktestStimulation';
import BacktestPerformanceMet from '../components/services-backtest/BacktestPerformanceMet';

const ServicesBacktest = () => {
  return (
    <React.Fragment>
      <BacktestBanner />
      <div className="blur-effect"></div>
      <BacktestStrategy />
      <BacktestPerformance />
      <BacktestStimulation />
      <BacktestPerformanceMet />
      <HomeTestimonial />
    </React.Fragment>
  );
};

export default ServicesBacktest;
